import mapKeys from 'lodash/mapKeys';
import { ACCESS_TYPO, BASE_URL } from '../../../configs/env';
import URLSearchParamsUtils from '../../../utils/URLSearchParams';
import {
  T3AllConfig,
  T3Config,
  T3PathConfig,
  T3StaticConfig
} from '../types/configs';

const headers: HeadersInit = new Headers();

if (ACCESS_TYPO) {
  // we are in dev-mode, so need to use basic auth to access typo3
  headers.append('Authorization', `Basic ${window.btoa(ACCESS_TYPO)}`);
}

/**
 * TODO:
 * refactor to one single request for each path
 * * initial request or first request with new language: allParams
 * * subsequent request within given language: contentParams
 */

export const t3RequestOptions: RequestInit = {
  credentials: 'include',
  headers
};

export const getContentParamsFromConfig = (config: T3Config) =>
  URLSearchParamsUtils.from({
    type: 110,
    ...mapKeys(config, (_, key) => `tx_ppiconfig_frontend[${key}]`)
  });

export const t3AllParamsConfig: T3AllConfig = {
  content: 1,
  meta: 1,
  menu: 1,
  cookie: 1,
  labels: 1,
  layer: 1,
  faqs: 1,
  redirects: 0,
  usedVehicleCenters: 1,
};

export const t3StaticParamsConfig: T3StaticConfig = {
  content: 0,
  meta: 1,
  menu: 0,
  cookie: 0,
  labels: 1,
  layer: 1,
  faqs: 0,
  redirects: 0,
  usedVehicleCenters: 1,
};

export const mkT3PrivacyParams = (searchValue: string) =>
  URLSearchParamsUtils.from({
    type: 130,
    'tx_ppiconfig_privacy[searchCode]': searchValue
  });

export const t3ContentParamsConfig: T3PathConfig = {
  content: 1,
  meta: 1,
  menu: 1,
  cookie: 1,
  labels: 0,
  layer: 0,
  faqs: 1,
  redirects: 0,
  usedVehicleCenters: 0,
};

export const t3BaseUrl = BASE_URL;
